import { getUrlParamValue, addUrlParamValue } from './UrlHelper'
import jsonp from 'shared/services/jsonp'

export const VIDEO_FORMATS = {
  prezi: 'prezi',
  wistia: 'wistia',
  facebook: 'facebook',
  youtube: 'youtube',
  vidyard: 'vidyard',
  vimeo: 'vimeo',
  slideshare: 'slideshare'
}

export const FORMAT_HANDLERS = {
  [VIDEO_FORMATS.prezi]: handlePrezi,
  [VIDEO_FORMATS.wistia]: handleWistia,
  [VIDEO_FORMATS.facebook]: handleFacebook,
  [VIDEO_FORMATS.youtube]: handleYouTube,
  [VIDEO_FORMATS.vidyard]: handleVidyard,
  [VIDEO_FORMATS.vimeo]: (url) => handleOEmbed(VIDEO_FORMATS.vimeo, url),
  [VIDEO_FORMATS.slideshare]: (url) => handleOEmbed(VIDEO_FORMATS.slideshare, url)
}

const OEMBED_APIS = {
  [VIDEO_FORMATS.vimeo]: "https://vimeo.com/api/oembed.json",
  [VIDEO_FORMATS.slideshare]: "https://www.slideshare.net/api/oembed/2"
}

export const getCurrentFormat = (url) => {
  switch (true) {
    case RegExp(/facebook\.com\/.+\/videos\/.+/).test(url):
      return VIDEO_FORMATS.facebook
    case RegExp(/prezi/).test(url):
      return VIDEO_FORMATS.prezi
    case RegExp(/(youtu\.be\/.+|youtube\.com\/.+)/).test(url):
      return VIDEO_FORMATS.youtube
    case RegExp(/wistia\.com\/medias\/.+/).test(url):
      return VIDEO_FORMATS.wistia
    case RegExp(/vidyard\.com\/watch\/.+/).test(url):
    case RegExp(/play\.vidyard\.com\/.+/).test(url):
      return VIDEO_FORMATS.vidyard
    case RegExp(/vimeo.com/).test(url):
      return VIDEO_FORMATS.vimeo
    case RegExp(/slideshare.net/).test(url):
      return VIDEO_FORMATS.slideshare
    default:
      null
  }
}

export const getFormattedUrlByFormat = (format, url) => {
  return FORMAT_HANDLERS[format](url)
}

export const getFormattedUrl = (url) => {
  const format = getCurrentFormat(url)
  const formattedUrl = FORMAT_HANDLERS[format] ? FORMAT_HANDLERS[format](url) : url
  return Promise.resolve(formattedUrl) //return promise due to OEmbed behaviour
}

function handleYouTube(url) {
  const videoUrl = /youtu\.be\//.test(url) ?
    url.split(".be/")[1] : getUrlParamValue(url, "v")

  let src = `//www.youtube.com/embed/${videoUrl}`
  src = src.replace(/(&amp;|&)/, "?")

  const timeParam = getUrlParamValue(url, "t") ||
    getUrlParamValue(url, "time_continue")

  if(timeParam){
    src = addUrlParamValue(src, "start", timeParam)
  }

  return addUrlParamValue(src, "rel", 0) //disable related video suggestions
}

function handlePrezi(url) {
  const strippedUrl = url.replace(/^.*prezi.com\//, "").replace(/\/.*$/, "")
  const urlParams = "bgcolor=ffffff&amp;lock_to_path=0&amp;autoplay=0&amp;autohide_ctrls=0&amp;features=undefined&amp;disabled_features=undefined"
  return `https://prezi.com/embed/${strippedUrl}?${urlParams}`
}

function handleWistia(url) {
  const wistiaUrlObj = url.split("medias/")
  return `${wistiaUrlObj[0]}embed/iframe/${wistiaUrlObj[1]}`
}

function handleFacebook(url) {
  return `https://www.facebook.com/plugins/video.php?href=${url}&show_text=0`
}

function handleVidyard(url) {
  if(url.includes("watch/")) {
    const vidyardUrlObj = url.split("watch/")
    return `//play.vidyard.com/${vidyardUrlObj[1]}`
  }

  return url
}

function handleOEmbed(format, url) {
  const api = OEMBED_APIS[format]

  return getEmbeddedData(api, url)
    .then(embedUrl => { return embedUrl })
    .catch(error => { throw error })
}

function getEmbeddedData(api, url) {
  return new Promise((resolve, reject) => {
    jsonp(`${api}?format=json&url=${url}`, (err, data) => {
      if(err) {
        reject(err)
      }

      resolve(data.html.replace(/.*?src=["'](.*?)["'].*/, "$1").trim())
    })
  })
}
